import type { AuthPermissionUser } from '../../services/authPermissions';

export interface InternalTaskAccessUser extends AuthPermissionUser {
  id?: string | null;
}

export interface InternalTaskAccessTask {
  createdById?: string | null;
}

export function canDeleteInternalTask(
  task: InternalTaskAccessTask | null | undefined,
  user: InternalTaskAccessUser | null | undefined
): boolean {
  if (!task) {
    return false;
  }

  return Boolean(task.createdById && task.createdById === user?.id) || user?.role === 'ADMIN';
}
